<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>
<div class="ibexfusion">
  <div class="ibexicon-header">
    <div class="ih-search">
      <mat-form-field style="color: black">
        <input (keyup)="onSearchChange($event)" [(ngModel)]="searchValue" matInput placeholder="Search">
      </mat-form-field>
    </div>
    <div class="ih-type">
      <div class="ih-type-button" [ngClass]="{active: iconType === 'normal'}"
            (click)="changeType('normal')">
        normal
      </div>
      <div class="ih-type-button" [ngClass]="{active: iconType === 'contrast'}"
           (click)="changeType('contrast')">
        contrast
      </div>
      <div class="ih-type-button" [ngClass]="{active: iconType === 'blank'}"
           (click)="changeType('blank')">
        blank
      </div>
    </div>
  </div>
  <div class="ibexicon-list">
    <div *ngFor="let icon of iconList" class="ibexicon-icon">
      <ibex-icon [name]="icon"></ibex-icon>
      <div >{{icon}}</div>
    </div>
  </div>
</div>
